import firebase from '../firebase';
import { v4 as uuidv4 } from 'uuid';

export const addBlog = obj => {
	return async dispatch => {
		dispatch({ type: 'ADD_BLOG_REQUEST' });
		let data;
		let image = obj.imageURL;
		let filename = image.name;
		let storageRef = await firebase
			.storage()
			.ref('medicine/' + filename)
			.put(image);

		let url = await storageRef.ref.getDownloadURL();
		data = {
			...obj,
			imageURL: url,
			createdAt: firebase.firestore.Timestamp.now(),
		};

		await firebase
			.firestore()
			.collection('blogs')
			.add(data)
			.then(res => {
				dispatch({ type: 'ADD_BLOG_SUCCESS' });
				return 'response';
			})
			.catch(err => {
				dispatch({ type: 'ADD_BLOG_SUCCESS' });
				alert(err.message);
			});
	};
};

export const getBlogs = () => {
	return async dispatch => {
		await firebase
			.firestore()
			.collection('blogs')
			.orderBy('createdAt', 'desc')
			.onSnapshot(query => {
				let allProducts = [];
				query.forEach(doc => {
					allProducts.push({ id: doc.id, ...doc.data() });
				});
				dispatch({ type: 'GET_ALL_BLOGS', payload: allProducts });
				return allProducts;
			});
	};
};

// export const getSingleProduct = id => {
// 	return async dispatch => {
// 		await firebase
// 			.firestore()
// 			.collection('products')
// 			.doc(id)
// 			.get()
// 			.then(res => {
// 				dispatch({ type: 'GET_SINGLE_PRODUCTS', payload: res.data() });
// 				return res.data();
// 			});
// 	};
// };

export const updateBlog = (id, obj) => async dispatch => {
	await firebase
		.firestore()
		.collection('blogs')
		.doc(id)
		.update(obj)
		.then(res => {
			dispatch({ type: 'UPDATE_BLOG' });
			return 'response';
		});
};
export const deleteBlog = id => async dispatch => {
	await firebase
		.firestore()
		.collection('blogs')
		.doc(id)
		.delete()
		.then(res => {
			dispatch({ type: 'DELETE_BLOG' });
			return 'response';
		});
};
